query GET_QUICKBOOK {
  quickBook {
    bookNowUrl
    tags
    price
    hourlyPrice
    lot {
      name
      isApproved
      facility {
        address {
          id
          address1
          address2
          city
          state
          zipCode
        }
        name
        images {
          file
          isThumbnail
        }
      }
    }
  }
}
